import * as React from "react";
import Timestamp from "components/common/Timestamp";
import InputField from "./InputField";
import NodeField from "./NodeField";
import StreamsField from "./StreamsField";
import PercentageField from "./PercentageField";
import EventDefinition from "./EventDefinition";
const FieldTypeValueRenderer = [
  {
    type: "date",
    render: (value, field, render) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value, render, field, format: "complete" })
  },
  {
    type: "boolean",
    render: (value, field, Component) => /* @__PURE__ */ React.createElement(Component, { value: String(value), field })
  },
  { type: "input", render: (value) => /* @__PURE__ */ React.createElement(InputField, { value: String(value) }) },
  { type: "node", render: (value) => /* @__PURE__ */ React.createElement(NodeField, { value: String(value) }) },
  {
    type: "streams",
    render: (value) => /* @__PURE__ */ React.createElement(StreamsField, { value })
  },
  { type: "percentage", render: (value) => /* @__PURE__ */ React.createElement(PercentageField, { value }) },
  {
    type: "event-definition-id",
    render: (value) => /* @__PURE__ */ React.createElement(EventDefinition, { value })
  }
];
export default FieldTypeValueRenderer;
